import React from 'react'
import './Header.scss';
import Coreai from '../../../Assets/Images/logo1.png';
import { Link } from 'react-router-dom';
export default function Header() {
    return (
        <div>
            <header>
                <div className="container">
                    <div className="header-alignment">
                        <a href="#home-section">
                        <div className="logo">
                            <img src={Coreai} alt="Coreai"/>
                        </div>
                        </a>
                        <div className="header-menu">
                            <nav>
                                <ul>
                                    <a href="#home-section">
                                        <li>Home</li>
                                    </a>
                                    <a href="#Business">
                                        <li>Business</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Services</li>
                                    </a>
                                    {/* <a href="#FinancialServices">
                                        <li>Financial Services</li>
                                    </a> */}
                                    <a href="#Technology">
                                        <li>Technology</li>
                                    </a>
                                   
                                    <a href="#AboutUs">
                                        <li>About Us</li>
                                    </a>
                                    <a href="#contact-page-align">
                                        <li>Contact</li>
                                    </a>
                                </ul>
                            </nav>
                            <div className="contact-us-button">
                                <button>Contact Us</button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}
